// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__C1inN","icon":"Footer_icon__T31an"};